import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="container flex-center" style={{ minHeight: '100vh' }}>
      <div className="text-center">
        <h1 style={{ fontSize: '4rem', color: 'var(--color-primary)', marginBottom: '8px' }}>
          WIE IS DE MOL?
        </h1>
        <p className="text-muted mb-3" style={{ fontSize: '1.25rem' }}>
          Buurthuis Team Quiz
        </p>
        
        <div className="flex gap-2" style={{ flexDirection: 'column', maxWidth: '300px', margin: '0 auto' }}>
          <button 
            className="btn btn-primary btn-large"
            onClick={() => navigate('/admin')}
          >
            🎮 Spelleider / Mol
          </button>
          
          <button 
            className="btn btn-secondary btn-large"
            onClick={() => navigate('/join')}
          >
            👥 Doe mee als Team
          </button>
        </div>
        
        <p className="text-muted mt-3" style={{ fontSize: '0.875rem' }}>
          Max 14 teams • Max 6 spelers per team
        </p>
      </div>
    </div>
  );
}
